import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function Header({children , page} ) {
  
  const [isAtiveState , setIsActiveState] = useState(false)

  return (
    <div className="header-container" 
      style={{
        ...(children ? {} : { aspectRatio: "auto", justifyContent: "normal" }),
        ...(page ? { aspectRatio: "7 / 1" } : {}),
      }}
    >
      <div className="header">
      {/* aspect-ratio */}
      {/* justify-content */}
        <div className="header-title" onClick={(() => setIsActiveState(!isAtiveState))}> 
          <div> 
              <svg  className={`arrowIcon ${isAtiveState ? "rotateArrowIcon" : ""}`} style={{transform: "rotate(180deg)"}} version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 443.52 443.52" ><g><g><path d="M336.226,209.591l-204.8-204.8c-6.78-6.548-17.584-6.36-24.132,0.42c-6.388,6.614-6.388,17.099,0,23.712l192.734,192.734    L107.294,414.391c-6.663,6.664-6.663,17.468,0,24.132c6.665,6.663,17.468,6.663,24.132,0l204.8-204.8    C342.889,227.058,342.889,216.255,336.226,209.591z"/></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>  
          </div>  
          <div className='nameState'> FA </div>
          <div> <img style={{width : "20px"}} src="image/fa.png" alt="" /> </div>

          {
            isAtiveState ?
            <>
              <div className='closeState' onClick={(() => setIsActiveState(false))}></div>
              <div className='States'>
              <Link className='item-State-lng' to={{ pathname: "/en" }} replace>
                <div>
                  <div> <img src="image/en.png" alt="" /> </div>
                  <div> EN </div>
                </div>
              </Link>
                {/* <Link className='item-State-lng' to={{ pathname: "/de" }} replace>
                  <div className='item-State-lng'>
                    <div> <img src="image/de.png" alt="" /> </div>
                    <div> De </div>
                  </div>
                </Link> */}
                <Link className='item-State-lng' to={{ pathname: "/fa" }} replace>
                  <div>
                    <div> <img src="image/fa.png" alt="" /> </div>
                    <div> Fa </div>
                  </div>
                </Link>
            </div>
            </>
          :
          ""
          }
        </div>
        <Link to={"/fa"}>
          <div className="header-logo-container">
            <img src="image/logo-header.png" alt="header-logo" className="header-logo" />
          </div>
        </Link>
      </div>
      
      {children}

    </div>
  );
};

export default Header;